import CreativeBackgroundImage from 'images/creative-background.svg'
import * as css from '../styles'

export const NoSourceURL = () => {
  return (
    <css.NoSourceUrlContainer>
      <CreativeBackgroundImage />
      <css.NoSourceUrlText>Choose a Classifications Source URL below.</css.NoSourceUrlText>
    </css.NoSourceUrlContainer>
  )
}
